// extracted by mini-css-extract-plugin
export default {"btn":"main-btn_btn__z3BjJ","red":"main-btn_red__dNJ-7"};